import React, { createContext, useContext, useEffect, useState } from 'react';
import { Auth } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let token = null;
    try { token = localStorage.getItem('rl_token'); } catch (e) { /* storage blocked */ }
    if (!token) {
      setLoading(false);
      return;
    }
    Auth.me()
      .then((u) => setUser(u))
      .catch(() => { try { localStorage.removeItem('rl_token'); } catch (e) {} })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await Auth.login({ email, password });
    try { localStorage.setItem('rl_token', r.token); } catch (e) {}
    setUser(r.user);
    return r.user;
  };

  const register = async (payload) => {
    const r = await Auth.register(payload);
    try { localStorage.setItem('rl_token', r.token); } catch (e) {}
    setUser(r.user);
    return r.user;
  };

  const loginWithGoogleSession = async (session_id) => {
    const r = await Auth.googleSession(session_id);
    try { localStorage.setItem('rl_token', r.token); } catch (e) {}
    setUser(r.user);
    return r.user;
  };

  // Used by the BYO Google OAuth callback — the backend has already minted
  // our JWT and redirected the browser to /auth/callback?token=...
  const loginWithPhoneToken = async (idToken) => {
    const r = await Auth.firebasePhone(idToken);
    try { localStorage.setItem('rl_token', r.token); } catch (e) {}
    setUser(r.user);
    return r;
  };

  const linkPhone = async (idToken) => {
    const r = await Auth.firebasePhoneLink(idToken);
    setUser(r.user);
    return r.user;
  };

  const updateProfile = async (payload) => {
    const u = await Auth.updateMe(payload);
    setUser(u);
    return u;
  };

  const loginWithToken = async (token) => {
    try { localStorage.setItem('rl_token', token); } catch (e) {}
    const u = await Auth.me();
    setUser(u);
    return u;
  };

  const logout = () => {
    try { localStorage.removeItem('rl_token'); } catch (e) {}
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, loginWithGoogleSession, loginWithToken, loginWithPhoneToken, linkPhone, updateProfile }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
